{{#if preview}}
  Show contact fields
{{else}}
  {{#> elements/_dt}}
    {{> elements/_label }}
  {{/elements/_dt}}
  <dd>
    <dl>
      {{#if relationship_types }}
        <dt>
          <label class="field-label" for="{{id}}_first_name">Relationship</label>
        </dt>
        <dd>
          {{sp_select_tag (sp_select_name prefix "[contact][" patient_contact_relationship_type_id "][patient_contact_relationship_type_id]")
            choices=select_items
            searchable=select_searchable
            selected=value.patient_contact_relationship_type_id
            id=id
            required=true
            includeBlank=false
          }}
        </dd>
      {{/if}}

      <input type="hidden" name="{{prefix}}[contact][{{patient_contact_relationship_type_id}}][patient_contact_assignment_id]" value="{{value.patient_contact_assignment_id}}" id="{{id}}_patient_contact_assignment_id">
      <input type="hidden" name="{{prefix}}[contact][{{patient_contact_relationship_type_id}}][id]" value="{{value.id}}" id="{{id}}_id">

      <dt>
        <label class="field-label" for="{{id}}_first_name">First Name</label>
      </dt>
      <dd>
        <input type="text" name="{{prefix}}[contact][{{patient_contact_relationship_type_id}}][first_name]" value="{{value.first_name}}" id="{{id}}_first_name">
      </dd>
      <dt>
        <label class="field-label" for="{{id}}_last_name">Last Name</label>
      </dt>
      <dd>
        <input type="text" name="{{prefix}}[contact][{{patient_contact_relationship_type_id}}][last_name]" value="{{value.last_name}}" id="{{id}}_last_name">
      </dd>
      <dt>
        <label class="field-label" for="{{id}}_phone_number">Phone Number</label>
      </dt>
      <dd>
        <input type="text" name="{{prefix}}[contact][{{patient_contact_relationship_type_id}}][phone_number]" value="{{value.phone_number}}" id="{{id}}_phone_number">
      </dd>
      <dt>
        <label class="field-label" for="{{id}}_email_address">Email Address</label>
      </dt>
      <dd>
        <input type="text" name="{{prefix}}[contact][{{patient_contact_relationship_type_id}}][email_address]" value="{{value.email_address}}" id="{{id}}_email_address">
      </dd>
    </dl>
  </dd>
{{/if}}
